module.exports = __webpack_public_path__ + "img/EXV_SD_Nav-Icon_Praemierte-Weine.156609ed.svg";